<template>
    <div :class="'relative w-full' + ' ' + wrapperCssClasses">
        <label
            v-if="label"
            :for="id"
            :class="'mb-2 block text-[14px] font-semibold' + ' ' + labelClasses"
        >
            <span v-html="label"></span>
        </label>

        <div class="relative flex w-full items-center">
            <!--            <label-->
            <!--                v-if="label && labelPosition == 'inside' && modelValue"-->
            <!--                :for="id"-->
            <!--                :class="-->
            <!--                    'absolute left-4 top-2 z-20 text-[12px] text-gray-500 ' +-->
            <!--                    labelClasses-->
            <!--                "-->
            <!--            >-->
            <!--                <span v-html="label"></span>-->
            <!--            </label>-->

            <template class="" v-if="ready">
                <Datepicker
                    :id="id"
                    :name="name"
                    class="w-full"
                    :hide-input-icon="true"
                    :clearable="clearable"
                    :input-class-name="
                        'datepicker w-full' +
                        ' ' +
                        themedCssClasses +
                        (disabled
                            ? ' cursor-not-allowed border-gray-400 opacity-50 '
                            : '') +
                        ($page.props.errors[name]
                            ? ' !border-red-400 !bg-none '
                            : '') +
                        (newModelValue
                            ? ''
                            : 'font-normal text-[20px] text-gray-500 p-1 !pt-3 pb-3 ')
                    "
                    v-model="newModelValue"
                    :enable-time-picker="false"
                    :min-date="minDateString"
                    :max-date="maxDateString"
                    format="MM/dd/yyyy"
                    :auto-apply="true"
                    @closed="updateInput"
                    @cleared="updateInput"
                    :disabled="disabled"
                >
                </Datepicker>
            </template>

            <svg
                v-if="$page.props.errors[name]"
                class="absolute right-2"
                width="22"
                height="22"
                viewBox="0 0 22 22"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    d="M11.0001 8.24977V10.0831V8.24977ZM11.0001 13.7498H11.0092H11.0001ZM4.64939 17.4164H17.3507C18.7624 17.4164 19.6442 15.8884 18.9384 14.6664L12.5877 3.66644C11.8819 2.44452 10.1182 2.44452 9.41239 3.66644L3.06172 14.6664C2.35589 15.8884 3.23772 17.4164 4.64939 17.4164Z"
                    stroke="#B4222A"
                    stroke-width="1.83333"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </svg>
        </div>

        <div class="text-sm text-gray-700" v-if="hint">
            {{ hint }}
        </div>

        <field-error :message="$page.props.errors[name]" />
    </div>
</template>

<script>
import FieldError from "@/Components/FieldError";
import dayjs from "dayjs";

export default {
    name: "FormInputDatepicker",
    components: {
        FieldError,
    },
    props: {
        id: {
            type: String,
            default: "",
        },
        label: {
            type: String,
            default: "",
        },
        hint: {
            type: String,
            default: "",
        },
        modelValue: {
            type: [String, Object],
            default: "",
        },
        minDate: {
            type: [String, Object],
            default: null,
        },
        maxDate: {
            type: [String, Object],
            default: null,
        },
        theme: {
            type: String,
            default: "bright",
        },
        cssClasses: {
            type: String,
            default:
                "rounded border-gray-50 focus:border-primary-300 focus:border w-full",
        },
        wrapperCssClasses: {
            type: String,
            default: "mb-4",
        },
        labelClasses: {
            type: String,
            default: "",
        },
        labelPosition: {
            type: String,
            default: "top",
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        name: {
            type: String,
            default: null,
        },
        forceDayOfYear: {
            type: String,
            default: null,
        },
        clearable: {
            type: Boolean,
            default: false,
        },
        autoComplete: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            newModelValue: this.modelValue,
            ready: false,
        };
    },
    methods: {
        updateInput() {
            let date =
                this.newModelValue !== null ? dayjs(this.newModelValue) : null;
            this.$emit("update:modelValue", date);
        },
    },
    computed: {
        minDateString() {
            let minDateString = null;

            if (this.minDate) {
                if (typeof this.minDate === "string") {
                    minDateString = this.minDate;
                }

                if (typeof this.minDate === "object") {
                    minDateString = dayjs(this.minDate).format("YYYY-MM-DD");
                }
            }

            return minDateString;
        },
        maxDateString() {
            let maxDateString = null;

            if (this.maxDate) {
                if (typeof this.maxDate === "string") {
                    maxDateString = this.maxDate;
                }

                if (typeof this.maxDate === "object") {
                    maxDateString = dayjs(this.maxDate).format("YYYY-MM-DD");
                }
            }

            return maxDateString;
        },
        themedCssClasses() {
            let css = this.theme + " ";

            if (this.labelPosition == "inside") {
                css += "!p-1 !pl-3 !pt-6 !pr-12 !text-base";
            } else {
                css += "!p-2 !pr-12 ";
            }

            css += " " + this.cssClasses;

            return css;
        },
    },
    created() {
        this.ready = true;
    },
};
</script>

<style lang="css">
.dp__clear_icon {
    position: absolute;
    top: 20px;
    right: 0;
    transform: translateY(-50%);
    cursor: pointer;
}
</style>
